/* ================================================== */
/* ===     LOADER “fullscreen-loader” (progresivo)  ===*/
/* ================================================== */
/* ① Constantes y refs */
const LOADER_MIN_MS = 2000;                       // al menos 2 s en pantalla
const loaderEl      = document.getElementById('fullscreen-loader');
const loaderMsgEl   = loaderEl?.querySelector('#loader-message');
const progressBarEl = loaderEl?.querySelector('.progress-bar');

const loaderMessages = [
  '¡Dándole forma a tu idea! 💫',
  'Añadiendo tu producto… 🛒',
  'Cocinando creatividad… 🖌️',
  'Ajustando los últimos detalles… 🔧'
];

const MIN_ORDER_QTY = 1; // Cantidad mínima de pedido

let msgTimer, startTs, stepsTotal = 0, stepsDone = 0;

/* ② Mostrar */
function showLoader(totalSteps = 1) {
  if (!loaderEl) return;           // por si falta el markup
  stepsTotal = totalSteps;
  stepsDone  = 0;
  progressBarEl.style.width = '0%';
  loaderMsgEl.textContent   = loaderMessages[0];
  loaderEl.classList.add('show');
  startTs = Date.now();

  let idx = 0;
  clearInterval(msgTimer);
  msgTimer = setInterval(() => {
    idx = (idx + 1) % loaderMessages.length;
    loaderMsgEl.textContent = loaderMessages[idx];
  }, 2000);
}

/* ③ Avanzar 1 paso */
function stepLoader() {
  if (!loaderEl) return;
  stepsDone++;
  const pct = Math.min(100, (stepsDone / stepsTotal) * 100);
  progressBarEl.style.width = pct + '%';
}

/* ④ Ocultar */
function hideLoader() {
  if (!loaderEl) return;
  const elapsed = Date.now() - startTs;
  const wait    = Math.max(0, LOADER_MIN_MS - elapsed);

  setTimeout(() => {
    progressBarEl.style.width = '100%';
    loaderEl.classList.remove('show');
    clearInterval(msgTimer);
  }, wait);
}


let pesoUnitario;
let pesoTotal;

function getPriceForQuantity(quantity) {
  const numericQuantity = Number(quantity) || 0;

  if (!window.tramosDePrecios || window.tramosDePrecios.length < 1) {
    return window.initialProductPrice || 0;
  }

  let tramosParaCalcular = [...window.tramosDePrecios].sort((a, b) => a.cantidad - b.cantidad);

  // REGLA DE OMISIÓN: Si el primer y último precio son iguales, se quita el primer tramo.
  if (tramosParaCalcular.length > 1) {
    const primerTramo = tramosParaCalcular[0];
    const ultimoTramo = tramosParaCalcular[tramosParaCalcular.length - 1];

    if (primerTramo.precio_final_calculado === ultimoTramo.precio_final_calculado) {
      tramosParaCalcular.shift(); // .shift() elimina el primer elemento del array.
    }
  }

  // REGLA 1: Para muestras (cantidad 0 o 1), el precio es el más bajo de TODOS los tramos originales.
  if (numericQuantity <= 1) {
    const todosLosPrecios = window.tramosDePrecios.map(t => t.precio_final_calculado);
    return Math.min(...todosLosPrecios);
  }

  // REGLA 2: Para el resto de cantidades, usamos la lista de tramos ya preparada.
  const tramosAplicables = tramosParaCalcular.filter(t => numericQuantity >= t.cantidad);

  // Si la cantidad SÍ entra en al menos un tramo, cogemos el más específico.
  if (tramosAplicables.length > 0) {
    return tramosAplicables[tramosAplicables.length - 1].precio_final_calculado;
  }
  
  // ▼▼▼ AQUÍ ESTÁ EL CAMBIO CLAVE ▼▼▼
  // Si la cantidad NO entra en ningún tramo (ej: es 2, y el primer tramo empieza en 250),
  // aplicamos el precio del primer tramo disponible en nuestra lista de cálculo.
  if (tramosParaCalcular.length > 0) {
    return tramosParaCalcular[0].precio_final_calculado; // Devolverá 0.95€
  }

  // Fallback final por si algo va mal.
  return window.initialProductPrice || 0;
}

// ——————————————————————————————
// 1) Helper: crea el producto oculto clonando la variante
// ——————————————————————————————
async function createDynamicVariant({ originalVariantId, qty, baseCost, extrasTotal, grandTotal, extras, imageFile }) {
  const fd = new FormData();
  fd.append('originalVariantId', originalVariantId);
  fd.append('qty',               qty);
  fd.append('baseCost',          baseCost);
  fd.append('extrasTotal',       extrasTotal);
  fd.append('grandTotal',        grandTotal);
  fd.append('extras',            extras);      // ya viene string
  fd.append('env',               1);
  fd.append('pesoUnitario', pesoUnitario.toFixed(2));
  fd.append('pesoTotal',    pesoTotal.toFixed(2));  
  if (imageFile) {
    fd.append('file', imageFile);
  }
  const resp = await fetch('https://calculadora.mktextil.com/create-item.php', {
    method: 'POST',
    body:   fd
  });
  if (!resp.ok) {
    const txt = await resp.text();
    throw new Error(`PHP app error: ${txt}`);
  }
  const data = await resp.json();
  if (!data.variantId) throw new Error('No se devolvió variantId');
  return { variantId: data.variantId, uniqueRef: data.uniqueRef };
}

let pricesMap = {};
window.addEventListener('DOMContentLoaded', async () => {
  // Modal
  const bsModal       = new bootstrap.Modal(document.getElementById('personalizeModal'));
  const btnPersonal   = document.getElementById('btnPersonalizar');
  
  btnPersonal.addEventListener('click', () => {
    const totalSelected = [...document.querySelectorAll('.qty-input')]
      .reduce((s, i) => s + (Number(i.value) || 0), 0);
    if (totalSelected === 0) {
      alert('Debes indicar al menos una unidad antes de personalizar.');
      return;
    }
    updateVariantQtySum();
    bsModal.show();
  });

  // Botón “Volver” cierra el modal
  const btnBack = document.getElementById('btnBack');
  if (btnBack) btnBack.addEventListener('click', () => bsModal.hide());

  // Inicializa precio/cantidad
  document.getElementById('quoteUnitPrice').value = initialProductPrice;
  const mainQty = document.querySelector('input[name="quantity"]');
  const qtyIn   = document.getElementById('quoteQty');
  if (mainQty) {
    qtyIn.value = mainQty.value;
    mainQty.addEventListener('input', () => {
      qtyIn.value = mainQty.value;
      updateVariantQtySum();
    });
  }

  // Sincroniza sumatorio de variantes con mínimo aplicado
  function updateVariantQtySum() {
    const warningEl = document.getElementById('minQtyWarning');
    const qtyIn = document.getElementById('quoteQty');

    // 1. Calculamos el número real de productos que el usuario ha seleccionado.
    const realTotal = [...document.querySelectorAll('.qty-input')]
                        .reduce((s, i) => s + (Number(i.value) || 0), 0);
    
    let calculatedTotal = realTotal;

    // 2. Comprobamos si se debe aplicar la regla del pedido mínimo.
    if (realTotal > 0 && realTotal < MIN_ORDER_QTY) {
      // Si es así, forzamos el total para el cálculo al mínimo.
      calculatedTotal = MIN_ORDER_QTY;
      
      // Y mostramos el mensaje de aviso.
      if (warningEl) {
        warningEl.innerHTML = `<strong>Aviso:</strong> Se está aplicando el coste de personalización para el pedido mínimo de <strong>${MIN_ORDER_QTY} unidades</strong>.`;
        warningEl.style.display = 'block';
      }
    } else {
      // Si no se aplica la regla, nos aseguramos de que el mensaje esté oculto.
      if (warningEl) {
        warningEl.style.display = 'none';
      }
    }

    // 3. Actualizamos el valor del input oculto con la cantidad que se usará para los cálculos.
    qtyIn.value = calculatedTotal;
    
    // 4. Actualizamos el resto de la interfaz.
    updateBreakdown();
    updateQuote();
  }
  document.querySelectorAll('.qty-input')
    .forEach(i=> i.addEventListener('input',updateVariantQtySum));

  // UI
  renderAreas(areasData);
  initQuotation();

  // Botón Añadir a la cesta
  document.getElementById('addToCartBtn')
    .addEventListener('click', addToCart);

  // Inicializar el desglose al cargar
  updateVariantQtySum();
});

// ——————————————————————————————————————————————
// 3) addToCart: por cada variante seleccionada clona y añade al carrito
// ——————————————————————————————————————————————
async function addToCart() {
  const unitPriceProd = parseFloat(document.getElementById('quoteUnitPrice').value) || 0;

  // 1) Selecciones de variantes (tallas)
  const selections = Array.from(document.querySelectorAll('.qty-input'))
    .map(i => {
      const q = parseInt(i.value,10) || 0;
      const id = parseInt(i.name.replace('quantity_',''),10);
      return { originalVariantId: id, qty: q };
    })
    .filter(sel => sel.qty > 0);

  const totalRealQty = selections.reduce((sum, s) => sum + s.qty, 0);
  if (totalRealQty > 0 && totalRealQty < MIN_ORDER_QTY) {
    alert(`Para la personalización se requiere un pedido mínimo de ${MIN_ORDER_QTY} unidades en total. Has seleccionado ${totalRealQty}.`);
    return;
  }

  const qtyForPricing = totalRealQty;

  showProcessing(selections.length * 2);

  // Ahora buscamos el file-input de cada área seleccionada
  let imageFile = null;
  document.querySelectorAll('.area-checkbox:checked').forEach(chk => {
    const idx = +chk.dataset.area;
    const fi  = document.querySelector(`.file-input[data-area="${idx}"]`);
    if (fi && fi.files.length) {
      imageFile = fi.files[0];
    }
  });

  // Calcular el total de clichés fuera del loop
  let totalClicheCost = 0;
  document.querySelectorAll('.area-checkbox:checked').forEach(chk => {
    const idx       = +chk.dataset.area;
    const area      = areasData[idx];
    const item      = document.getElementById(`collapse${idx}`).closest('.accordion-item');
    const techSel   = item.querySelector('.tecnica-select');
    const colSel    = item.querySelector('.colores-select');
    const repite    = item.querySelector('.repite-checkbox').checked;
    const t         = area.tecnicas[+techSel.value];
    const selectedColors = parseInt(colSel.value, 10);
    const priceEntry = (t.precios || [])
      .filter(p => p.cantidad_minima <= qtyForPricing && parseInt(p.numero_colores, 10) === selectedColors)
      .sort((a,b) => a.cantidad_minima - b.cantidad_minima)
      .pop() || { precio_unitario:0, cargo_cliche:0 };

    let cargoClicheFijo = repite ? priceEntry.cargo_cliche / 2 : priceEntry.cargo_cliche;
    totalClicheCost += cargoClicheFijo;
  });

  try {
    for (const [index, { originalVariantId, qty }] of selections.entries()) {
      const baseCost = unitPriceProd * qty;

      // 2) Calcular extras
      let extrasTotal = 0;

      const extras = [];
      document.querySelectorAll('.area-checkbox:checked').forEach(chk => {
        const idx       = +chk.dataset.area;
        const area      = areasData[idx];
        pesoUnitario = area.peso_unitario || 0;
        pesoTotal    = pesoUnitario * qty;
        const item      = document.getElementById(`collapse${idx}`).closest('.accordion-item');
        const techSel   = item.querySelector('.tecnica-select');
        const colSel    = item.querySelector('.colores-select');
        const repite    = item.querySelector('.repite-checkbox').checked;
        const pantone = item.querySelector('.pantone-input').value || '';
        const t         = area.tecnicas[+techSel.value];
        const selectedColors = parseInt(colSel.value, 10);

        const priceEntry = (t.precios || [])
          .filter(p => p.cantidad_minima <= qtyForPricing && parseInt(p.numero_colores, 10) === selectedColors)
          .sort((a,b) => a.cantidad_minima - b.cantidad_minima)
          .pop() || { precio_unitario:0, cargo_cliche:0 };

        let subTotalMarcaje = priceEntry.precio_unitario * qty;

        let cargoClicheFijo = repite ? priceEntry.cargo_cliche / 2 : priceEntry.cargo_cliche;
        const clicheToReport = (index === 0) ? cargoClicheFijo : 0;

        extrasTotal += subTotalMarcaje;

        extras.push({
          area:            area.nombre_area,
          tecnica:         t.nombre.trim(),
          cantidad:        qty,
          precio_unitario: priceEntry.precio_unitario,
          subtotal:        subTotalMarcaje,
          pantone:         pantone,
          cargo_cliche:    clicheToReport
        });
      });

      if (index === 0) {
        extrasTotal += totalClicheCost;
      }

      const grandTotal = baseCost + extrasTotal;

      // DEBUG: comprueba en consola
      console.log('extras  =', extras);
      console.log('extrasTotal =', extrasTotal);

      // 3) Crear el variant dinámico y obtener uniqueRef
      const { variantId, uniqueRef, imageUrl } = await createDynamicVariant({
        originalVariantId,
        qty,
        baseCost,
        extrasTotal,
        grandTotal,
        extras: JSON.stringify(extras),
        imageFile,
        pesoUnitario,
        pesoTotal
      });

      stepLoader();

      // 4) Montar properties legibles (forzamos tipo Number)
      const base   = Number(baseCost)     || 0;
      const extraT = Number(extrasTotal)  || 0;
      const grand  = Number(grandTotal)   || 0;

      const props = {
        'Coste base (€)':          base.toFixed(2).replace('.',','),
        'Total personalización (€)': extraT.toFixed(2).replace('.',','),
        'Total (€)':               grand.toFixed(2).replace('.',','),
        'Imagen personalización':  imageUrl
      };
      extras.forEach((e,i) => {
        const idx = i + 1;
        props[`Área ${idx}`]           = e.area;
        props[`Técnica ${idx}`]        = e.tecnica;
        props[`Unidades ${idx}`]       = e.cantidad;
        props[`Pantone ${idx}`]        = e.pantone;

        // Convertimos a número antes de toFixed
        const pu   = parseFloat(e.precio_unitario)  || 0;
        const sub  = parseFloat(e.subtotal)         || 0;
        const cl   = parseFloat(e.cargo_cliche)     || 0;

        props[`Precio unitario ${idx} (€)`] = pu.toFixed(2).replace('.',',');
        props[`Subtotal marcaje ${idx} (€)`]= sub.toFixed(2).replace('.',',');
        props[`Cliché ${idx} (€)`]          = cl.toFixed(2).replace('.',',');
      });
      // 5) Añadir al final el unique_ref
      props['Referencia única'] = uniqueRef;

      // 6) Añadir al carrito
      const cartRes = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({
          id:          variantId,
          quantity:    1,
          properties: props
        })
      });
      if (!cartRes.ok) {
        const t = await cartRes.text();
        throw new Error(`Error añadiendo al carrito: ${t}`);
      }
    }
    stepLoader();
    hideProcessing();
    // 7) Redirigir al carrito
    window.location.href = '/cart';

  } catch(err) {
    console.error('addToCart error:', err);
    alert('Error al añadir al carrito. Revisa la consola.');
  }
}

function showProcessing(totalSteps = 1) {
  // sigue enseñando tu overlay semitransparente, si lo quieres
  const ov = document.getElementById('processingOverlay');
  if (ov) ov.style.display = 'flex';

  // ahora lanza el spinner con progreso
  showLoader(totalSteps);
}

function hideProcessing() {
  const ov = document.getElementById('processingOverlay');
  if (ov) ov.style.display = 'none';

  hideLoader();
}

function renderAreas(data) {
  const acc = document.getElementById('areasAccordion');
  acc.innerHTML = '';
  data.forEach((area, idx) => {
    const headId     = `heading${idx}`;
    const collapseId = `collapse${idx}`;
    const options    = area.tecnicas.map((t,i) =>
      `<option value="${i}">${t.nombre.trim()} (${t.colores_max} colores)</option>`
    ).join('');

    acc.insertAdjacentHTML('beforeend', `
      <div class="accordion-item">
        <h2 class="accordion-header" id="${headId}">
          <button class="accordion-button collapsed d-flex align-items-center"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#${collapseId}"
                  aria-expanded="false"
                  aria-controls="${collapseId}">
            <input class="form-check-input me-2 area-checkbox"
                   type="checkbox"
                   data-area="${idx}">
            <div>
              <div>${area.zona}</div>
              <small>${area.nombre_area}</small>
            </div>
          </button>
        </h2>
        <div id="${collapseId}"
             class="accordion-collapse collapse"
             aria-labelledby="${headId}"
             data-bs-parent="#areasAccordion">
          <div class="accordion-body">

            <!-- Técnica / colores -->
            <div class="row g-2 mb-3">
              <div class="col-md-6">
                <label class="form-label">Técnica:</label>
                <select class="form-select tecnica-select" data-area="${idx}">
                  ${options}
                </select>
              </div>
              <div class="col-md-6">
                <label class="form-label">Nº Colores:</label>
                <select class="form-select colores-select" data-area="${idx}" disabled></select>
              </div>
            </div>

            <!-- Medidas -->
            <div class="row g-2 mb-3">
              <div class="col">
                <label class="form-label">Ancho (mm):</label>
                <input type="number" class="form-control ancho-input" readonly>
              </div>
              <div class="col">
                <label class="form-label">Alto (mm):</label>
                <input type="number" class="form-control alto-input" readonly>
              </div>
            </div>

            <!-- Repetición, Pantone, archivo, obs -->
            <div class="form-check mb-3">
              <input class="form-check-input repite-checkbox"
                     type="checkbox"
                     id="repite${idx}">
              <label class="form-check-label" for="repite${idx}">
      Repetición Cliché  <br><small class="text-muted">
(clicar clientes que repiten pedido y grabación en el mismo producto)
    </small>
            </div>
            <div class="mb-3">
              <label class="form-label">PANTONE:</label>
            <div class="input-group">
              <!-- Botón que abre el selector nativo -->
              <button type="button" class="input-group-text pantone-picker" title="Elegir color">
                🎨
              </button>
              <input
                type="text"
                class="form-control pantone-input"
                placeholder="Introduce código Pantone"/>
              <!-- selector de color oculto -->
              <input type="color" class="pantone-native d-none"/>
            </div>
            <div class="mt-2 pantone-presets">
              <!-- 6 colores predefinidos -->
              ${['#000000','#FFFFFF','#FF0000','#00FF00','#0000FF','#FFD700']
                .map(c => `<button type="button" class="btn btn-sm pantone-swatch mx-1" 
                               data-color="${c}" 
                               style="background:${c};border:1px solid #ccc;width:24px;height:24px;">
                           </button>`)
                .join('')}
            </div>
            </div>
            <div class="mb-3">
              <label class="form-label">Adjuntar diseño (.zip con PDF, JPG o PNG dentro):</label>
              <input type="file" class="file-input form-control form-control-sm" accept=".zip,application/zip" data-area="${idx}">
            </div>
            <div class="mb-3">
              <label class="form-label">Observaciones:</label>
              <textarea class="form-control" rows="2"></textarea>
            </div>

          </div>
        </div>
      </div>
    `);

    const item     = acc.lastElementChild;
    const collapse = item.querySelector('.accordion-collapse');
    const chk      = item.querySelector('.area-checkbox');
    const techSel  = item.querySelector('.tecnica-select');

    collapse.addEventListener('shown.bs.collapse', () => onAreaSelected(idx));
    techSel.addEventListener('change',  () => updateAreaOptions(idx));
    chk.addEventListener('change',      () => updateQuote());

    updateAreaOptions(idx);
  });
  // Selecciona y abre la primera área por defecto
  const firstChk = document.querySelector('#areasAccordion .area-checkbox');
  if (firstChk) {
    firstChk.checked = true;
    const firstCollapse = document.querySelector('#areasAccordion .accordion-collapse');
    if (firstCollapse) new bootstrap.Collapse(firstCollapse, { toggle: true });
    updateQuote();
  }
}

document.addEventListener('click', e => {
  if (e.target.matches('.pantone-swatch')) {
    const btn   = e.target;
    const color = btn.dataset.color;
    // buscamos el input dentro del mismo accordion-item
    const container = btn.closest('.accordion-body');
    const input = container.querySelector('.pantone-input');
    if (input) {
      input.value = color;
      // opcional: cambiar fondo del input al color elegido
      input.style.backgroundColor = color;
      input.style.color = getContrastYIQ(color);
    }
  }
});

// ——————————————————————————————
// NUEVO: Abrir selector nativo al pulsar el icono
// ——————————————————————————————
document.addEventListener('click', e => {
  if (e.target.matches('.pantone-picker')) {
    const container = e.target.closest('.input-group');
    const native    = container.querySelector('.pantone-native');
    native.click();
  }
});

// ——————————————————————————————
// NUEVO: Capturar cambio del selector nativo
// ——————————————————————————————
document.addEventListener('input', e => {
  if (e.target.matches('.pantone-native')) {
    const color = e.target.value;
    const container = e.target.closest('.input-group');
    const input     = container.querySelector('.pantone-input');
    input.value = color;
    input.style.backgroundColor = color;
    input.style.color = getContrastYIQ(color);
  }
});

function getContrastYIQ(hex) {
  hex = hex.replace('#','');
  const r = parseInt(hex.substr(0,2),16),
        g = parseInt(hex.substr(2,2),16),
        b = parseInt(hex.substr(4,2),16);
  return ((r*299)+(g*587)+(b*114))/1000 >= 128 ? '#000':'#fff';
}

function updateAreaOptions(idx) {
  const area     = areasData[idx];
  const item     = document.getElementById(`collapse${idx}`)
                      .closest('.accordion-item');
  const techSel  = item.querySelector('.tecnica-select');
  const colorSel = item.querySelector('.colores-select');
  const anchoIn  = item.querySelector('.ancho-input');
  const altoIn   = item.querySelector('.alto-input');

  const t = area.tecnicas[parseInt(techSel.value,10)];
  anchoIn.value = t.ancho;
  altoIn.value  = t.alto;

  colorSel.innerHTML = '';
  const uniqueColors = Array.from(new Set(t.precios.map(p => p.numero_colores))).sort((a,b)=>parseInt(a)-parseInt(b));

  // ▼▼▼ LÓGICA CORREGIDA ▼▼▼
  // Ahora comprueba si el color es un número o un texto
  uniqueColors.forEach(col => {
    const isNumeric = !isNaN(parseInt(col, 10));
    
    if (isNumeric) {
      const colNum = parseInt(col, 10);
      colorSel.innerHTML += `<option value="${col}">${colNum} color${colNum > 1 ? 'es' : ''}</option>`;
    } else {
      // Si no es numérico (ej: "Full color"), lo usamos directamente
      colorSel.innerHTML += `<option value="${col}">${col}</option>`;
    }
  });
  // ▲▲▲ FIN DE LA CORRECCIÓN ▲▲▲
  colorSel.disabled = false;

  if (item.querySelector('.area-checkbox').checked) updateQuote();
}

function onAreaSelected(idx) {
  const area = areasData[idx];
  const imgSrc = area.imagen;

  document.getElementById('quoteProductoImg').src = imgSrc;

  const quoteImg = document.getElementById('quoteProductoImg');
  if (quoteImg) quoteImg.src = imgSrc;
}

function initQuotation() {
  document.getElementById('quoteUnitPrice')
          .addEventListener('input', updateQuote);
  document.getElementById('quoteQty')
          .addEventListener('input', updateQuote);

  document.getElementById('areasAccordion')
    .addEventListener('change', e => {
      if (e.target.matches('.area-checkbox, .tecnica-select, .colores-select, .repite-checkbox')) {
        updateQuote();
      }
    });

  updateQuote();
}

function updateQuote() {
  const totalQtyFromCalc = Number(document.getElementById('quoteQty').value) || 0;
  let dynamicUnitPrice = getPriceForQuantity(totalQtyFromCalc);
  console.log(dynamicUnitPrice);

  const unitPriceInput = document.getElementById('quoteUnitPrice');
  unitPriceInput.value = dynamicUnitPrice.toFixed(2);

  // ▼▼▼ AÑADE ESTE BLOQUE ▼▼▼
  // 1. Buscamos el elemento que muestra el precio principal en la página.
  const mainPriceDisplay = document.querySelector('price-list sale-price');

  // 2. Si lo encontramos, actualizamos su contenido con el nuevo precio.
  if (mainPriceDisplay) {
    // Usamos tu función formatMoney() que ya se encarga de poner el "€" y la coma.
    // Mantenemos el span para accesibilidad (lectores de pantalla).
    mainPriceDisplay.innerHTML = `<span class="sr-only">Precio de oferta</span>${formatMoney(dynamicUnitPrice)}`;
  }
  // ▲▲▲ FIN DEL BLOQUE A AÑADIR ▲▲▲

  let qty = totalQtyFromCalc;
  if (qty > 0 && qty < MIN_ORDER_QTY) qty = MIN_ORDER_QTY;

  const unitPriceProd = parseFloat(dynamicUnitPrice) || 0;
  const baseCost      = unitPriceProd * qty;
  document.getElementById('baseCost').textContent = formatMoney(baseCost);

  const extrasTable = document.getElementById('extrasTable');
  extrasTable.innerHTML = '';
  let extrasTotal = 0;

  document.querySelectorAll('.area-checkbox:checked').forEach(chk => {
  const idx = parseInt(chk.dataset.area, 10);
  const area = areasData[idx];
  const item = document.getElementById(`collapse${idx}`).closest('.accordion-item');
  const techSel = item.querySelector('.tecnica-select');
  const colSel = item.querySelector('.colores-select');
  const repite = item.querySelector('.repite-checkbox').checked;

  const t = area.tecnicas[parseInt(techSel.value, 10)];
  const selectedColorsStr = colSel.value;
  let selectedColors = parseInt(selectedColorsStr, 10);

  // Elegimos el tramo apropiado según qty y el número de colores seleccionado
  let priceEntry;
  if (isNaN(selectedColors) && selectedColorsStr === "Full color") {
    // Caso especial para Full color: toma el primer precio disponible sin filtrar por numero_colores
    priceEntry = (t.precios || [])
      .filter(p => p.cantidad_minima <= qty)
      .sort((a, b) => a.cantidad_minima - b.cantidad_minima)
      .pop() || { precio_unitario: 0, cargo_cliche: 0 };
  } else {
    // Caso normal: filtra por numero_colores
    priceEntry = (t.precios || [])
      .filter(p => p.cantidad_minima <= qty && p.numero_colores === selectedColorsStr)
      .sort((a, b) => a.cantidad_minima - b.cantidad_minima)
      .pop() || { precio_unitario: 0, cargo_cliche: 0 };
  }

  let subTotalMarcaje = priceEntry.precio_unitario * qty;
  let cargoClicheFijo = repite ? priceEntry.cargo_cliche / 2 : priceEntry.cargo_cliche;

  const subTotalArea = subTotalMarcaje + cargoClicheFijo;
  extrasTotal += subTotalArea;

  extrasTable.insertAdjacentHTML('beforeend', `
    <tr>
      <td>${area.nombre_area} — ${t.nombre.trim()} (${selectedColorsStr})</td>
      <td class="text-center">${qty}</td>
      <td class="text-end">${formatMoney(priceEntry.precio_unitario)}</td>
      <td class="text-end">${formatMoney(subTotalMarcaje)}</td>
    </tr>
    <tr>
      <td class="ps-3">${repite ? 'Repetición Cliché' : 'Cliché'}</td>
      <td class="text-center">${isNaN(selectedColors) ? selectedColorsStr : selectedColors}</td>
      <td class="text-end">${formatMoney(cargoClicheFijo / (isNaN(selectedColors) ? 1 : selectedColors))}</td>
      <td class="text-end">${formatMoney(cargoClicheFijo)}</td>
    </tr>
  `);
});

  document.getElementById('extrasTotal').textContent = formatMoney(extrasTotal);
  const grandTotal = baseCost + extrasTotal;
  document.getElementById('grandTotal').textContent  = formatMoney(grandTotal);

  const totalPerUnitRow = document.querySelector('.total-per-unit-row');
  const totalPerUnitEl = document.getElementById('totalPerUnit');
  if (qty > 0) {
    const perUnitPrice = grandTotal / qty;
    totalPerUnitEl.textContent = formatMoney(perUnitPrice);
    totalPerUnitRow.style.display = '';
  } else {
    totalPerUnitRow.style.display = 'none';
  }
}

function formatMoney(n) {
  return n.toFixed(2).replace('.',',') + '€';
}
function updateBreakdown() {
  const rowsContainer = document.getElementById('breakdownProductRows');
  if (!rowsContainer) return;

  rowsContainer.innerHTML = '';

  const unitPriceProd = parseFloat(document.getElementById('quoteUnitPrice').value) || 0;

  document.querySelectorAll('.qty-input').forEach(input => {
    const qty = parseInt(input.value, 10) || 0;
    if (qty > 0) {
      const tr = input.closest('tr');

      // --- CAMBIOS AQUÍ ---
      const colorCell = tr.querySelector('.color-cell');
      const sizeCell = tr.querySelector('.size-cell');

      let colorName = 'Variante'; // Valor por defecto
      // Se busca el nodo de texto para evitar duplicados del swatch
      if (colorCell) {
        for (const node of colorCell.childNodes) {
          // nodeType === 3 significa que es un nodo de texto
          if (node.nodeType === 3 && node.textContent.trim() !== '') {
            colorName = node.textContent.trim();
            break; // Se encontró el texto, se sale del bucle
          }
        }
      }

      const sizeName = sizeCell ? sizeCell.innerText.trim() : '';

      // Construye el nombre final de la variante
      let variantName = colorName;
      if (sizeName) {
        // Se asegura de no añadir guion si la talla ya lo tiene o está vacía
        variantName = `${colorName} - ${sizeName}`;
      }
      // --- FIN DE LOS CAMBIOS ---

      const subTotal = qty * unitPriceProd;

      const row = document.createElement('div');
      row.className = 'variant-breakdown-row';
      row.innerHTML = `
        <span>${variantName}</span>
        <span>${qty}</span>
        <span>${formatMoney(unitPriceProd)}</span>
        <span>${formatMoney(subTotal)}</span>
      `;
      rowsContainer.appendChild(row);
    }
  });
}